module.exports = __webpack_public_path__ + "img/pieceOneImg6.378eb7e.png";